module.exports = __webpack_public_path__ + "media/components/src/assets/images/logo/check_disable-9064354a1d54b956e9ae9a3d02c40b47.svg";